import React, { Component } from "react";
import jsonData from "../../db.json";

class FaqSection extends Component {
  state = {
    data: jsonData.themeOneFaqSection,
    faqData: jsonData.themeOneFaqSection.faqData,
    faqDataTwo: jsonData.themeOneFaqSection.faqDataTwo,
  };

  render() {
    return (
      <section className="section faq-area style-two ptb_100" id="faq">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-7">
              {/* Section Heading */}
              <div className="section-heading text-center">
                <h2 className="text-capitalize">{this.state.data.heading}</h2>
                <p className="d-none d-sm-block mt-4">
                  Answers to the most common questions about MoneyMonk loans
                  and process.
                </p>
                <p className="d-block d-sm-none mt-4">
                  Answers to the most common questions about MoneyMonk loans
                  and process.
                </p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12">
              {/* FAQ Content */}
              <div className="faq-content">
                {/* sApp Accordion */}
                <div className="accordion" id="sApp-accordion">
                  <div className="row justify-content-center">
                    <div className="col-12 col-md-6">
                      <div className="card border-0">
                        {/* Card Header */}
                        <div className="card-header bg-inherit border-0 p-0">
                          <h2 className="mb-0">
                            <button className="btn px-0 py-2" type="button">
                              1. What is Money Monk, and why should I choose it
                              over a traditional bank loan?
                            </button>
                          </h2>
                        </div>
                        {/* Card Body */}
                        <div className="card-body px-0 py-3">
                          MoneyMonk is an innovative digital product offered by
                          Monk Capital Pvt Ltd, specializing in providing
                          personal loans to both salaried and self-employed
                          professionals. The main advantages over a traditional
                          bank loan are speed and convenience. The entire
                          process is completely digitally driven and can be
                          completed online with minimal documentation, generally
                          taking no more than 15 minutes. Upon approval, the
                          money is typically received in your account instantly.
                        </div>
                      </div>
                      <div className="card border-0">
                        {/* Card Header */}
                        <div className="card-header bg-inherit border-0 p-0">
                          <h2 className="mb-0">
                            <button className="btn px-0 py-2" type="button">
                              2. What are the key eligibility criteria for
                              applying for a loan?
                            </button>
                          </h2>
                        </div>
                        {/* Card Body */}
                        <div className="card-body px-0 py-3">
                          To be eligible for a personal loan through LoanFront,
                          applicants must be Indian Citizens over 21 years of
                          age and have a stable monthly source of income of
                          above ₹18,000 (with an annual household income greater
                          than ₹3 Lakhs). You must be a salaried or
                          self-employed individual. Crucially, for the
                          application process, your Aadhaar must be linked with
                          your PAN, and the mobile number used for registration
                          must be linked with your Aadhaar card for e-signing
                          the Loan Agreement.
                        </div>
                      </div>
                      <div className="card border-0">
                        {/* Card Header */}
                        <div className="card-header bg-inherit border-0 p-0">
                          <h2 className="mb-0">
                            <button className="btn px-0 py-2" type="button">
                              3. What are the available loan amounts, interest
                              rates, and repayment tenures?
                            </button>
                          </h2>
                        </div>
                        {/* Card Body */}
                        <div className="card-body px-0 py-3">
                          MoneyMonk offers loan amounts ranging from ₹25000 up
                          to ₹2 Lakhs. The products include:
                          <br />{" "}
                          <ul style={{ paddingLeft: 30 }}>
                            <li style={{ listStyleType: "disc" }}>
                              Salary advance loans (ranging from ₹25000 to
                              ₹200,000).
                            </li>
                            <li style={{ listStyleType: "disc" }}>
                              Short-term personal loans (ranging from ₹25,000 to
                              ₹2 Lakhs).{" "}
                            </li>
                          </ul>
                          The loan tenure options are easy and range between 62
                          days to 180 days (equivalent to 2 to 6 EMIs). Interest
                          rates are dynamic, starting from 12% up to a maximum
                          cap of 36% per annum, depending on the customer's risk
                          profile and the product available.
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      {/* Single Card */}
                      <div className="card border-0">
                        {/* Card Header */}
                        <div className="card-header bg-inherit border-0 p-0">
                          <h2 className="mb-0">
                            <button className="btn px-0 py-2" type="button">
                              4. What is the step-by-step process for applying
                              for a loan using the app?
                            </button>
                          </h2>
                        </div>
                        {/* Card Body */}
                        <div className="card-body px-0 py-3">
                          The process is designed to be simple and
                          user-friendly:
                          <br />
                          <ol style={{ paddingLeft: 30 }}>
                            <li style={{ listStyleType: "numeric" }}>
                              Download the MoneyMonk app from the Play Store.
                            </li>
                            <li style={{ listStyleType: "numeric" }}>
                              Register using your Mobile Number or Gmail
                              account.
                            </li>
                            <li style={{ listStyleType: "numeric" }}>
                              Fill basic details to check your eligibility.
                            </li>
                            <li style={{ listStyleType: "numeric" }}>
                              Perform Video KYC.
                            </li>
                            <li style={{ listStyleType: "numeric" }}>
                              Choose your loan amount.
                            </li>
                            <li style={{ listStyleType: "numeric" }}>
                              Provide bank account details for disbursement.
                            </li>{" "}
                            <li style={{ listStyleType: "numeric" }}>
                              E-sign the loan agreement.
                            </li>
                            <li style={{ listStyleType: "numeric" }}>
                              Receive the loan amount directly in your bank
                              account.
                            </li>
                          </ol>
                        </div>
                      </div>
                      <div className="card border-0">
                        {/* Card Header */}
                        <div className="card-header bg-inherit border-0 p-0">
                          <h2 className="mb-0">
                            <button className="btn px-0 py-2" type="button">
                              5. Are there any fees or hidden charges associated
                              with the loan?
                            </button>
                          </h2>
                        </div>
                        {/* Card Body */}
                        <div className="card-body px-0 py-3">
                          MoneyMonk emphasizes that all charges are transparent
                          and communicated upfront via the Loan Sanction Letter,
                          Loan Disbursal Letter, Loan Agreement, and GST
                          invoices; there are no hidden charges. A standard
                          processing fee is charged by all financial entities
                          for operational efforts (like credit checks) and is
                          deducted upfront from your loan amount. All the
                          charges are disclosed during the sanction of the loan
                          by way of Key Fact Statement as required by Reserve
                          Bank of India.
                        </div>
                      </div>
                      <div className="card border-0">
                        {/* Card Header */}
                        <div className="card-header bg-inherit border-0 p-0">
                          <h2 className="mb-0">
                            <button className="btn px-0 py-2" type="button">
                              6. What are the consequences of not paying the
                              loan on time?
                            </button>
                          </h2>
                        </div>
                        {/* Card Body */}
                        <div className="card-body px-0 py-3">
                          Timely repayment is extremely crucial. If you default
                          on your payment:
                          <br />
                          <ul style={{ paddingLeft: 30 }}>
                            <li style={{ listStyleType: "disc" }}>
                              Late payment charges will be incurred, including a
                              per-day penalty charge starting from the first day
                              overdue. The rate of annualized penal charges is
                              36%, applied daily.These charges are calculated
                              after a grace period 2 days.
                            </li>
                            <li style={{ listStyleType: "disc" }}>
                              Your Credit Score will be affected. Delayed
                              payments are reported to Credit Bureaus (CRIF /
                              CIBIL / Experian).
                            </li>
                            <li style={{ listStyleType: "disc" }}>
                              You will automatically become ineligible for
                              availing quicker personal loans of a higher value
                              from LoanFront in the future.
                            </li>
                          </ul>
                          For accounts where the EMI remains unpaid for more
                          than 90 days, the account shall become a
                          Non-Performing Asset (NPA).
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row justify-content-center">
                    <p className="text-body text-center pt-4 fw-5">
                      {this.state.data.faqText}{" "}
                      <a href="#contact">{this.state.data.faqTextLink}</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default FaqSection;
